import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-nowrap items-stretch" }
const _hoisted_2 = { class: "flex items-center justify-center flex-grow" }
const _hoisted_3 = {
  class: "rounded-12 border-2 border-charcoal relative rise-animation",
  style: { width: '360px' }
}
const _hoisted_4 = { class: "text-center mx-34 pt-20" }
const _hoisted_5 = { class: "text-center mx-34 pb-20" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Welcome to ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "flex mx-34 my-20 gap-12" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" foyer ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PagePath = _resolveComponent("PagePath")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PagePath),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx._icon), 1),
        _createElementVNode("h1", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx._name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/-",
            class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createPage && _ctx.createPage(...args))),
            class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center cursor-pointer"
          }, " new ")
        ])
      ])
    ])
  ]))
}